import invariant from 'invariant';

const hasOwnProperty = Object.prototype.hasOwnProperty;

const defaultMessages = {
  date: 'Date',
  time: 'Time',
  event: 'Event',
  allDay: 'all day',
  week: 'week',
  day: 'day',
  month: 'month',
  previous: 'back',
  next: 'next',
  yesterday: 'yesterday',
  tomorrow: 'tomorrow',
  today: 'today',
  agenda: 'agenda',

  showMore: total => `+${total} more`,
};

export default function messages(msgs) {
  return {
    ...defaultMessages,
    ...msgs,
  };
}

export function set(key, msg) {
  invariant(hasOwnProperty.call(messages, key),
    `The message key: "${key}" is not a valid message name. ` +
    `valid keys are: ${Object.keys(messages).join(', ')}`
  );

  messages[key] = msg;
}

export function result(msg, ...args) {
  return typeof msg === 'function' ? msg(args) : msg;
}
